export default __webpack_public_path__ + "static/media/kingspan-logo.1e103ca9.svg";